import * as React from 'react';
import { BodyText, CaseReportSectionTitle } from 'src/components/atomsLegacy';
import { ParsedEvidenceDetailsType } from 'src/graphql/generated';
import { NamedOffendersContainer } from './CaseReportEventNamedOffenders.styles';

export interface CaseReportEventNamedOffendersListProps {
  namedOffenders: ParsedEvidenceDetailsType[];
  'data-testid'?: string;
}

export const CaseReportEventNamedOffendersList: React.FC<
  CaseReportEventNamedOffendersListProps
> = ({ namedOffenders, ...props }) => {
  const names = namedOffenders.length
    ? namedOffenders.map((offender) => offender.value.name)
    : ['—'];
  return (
    <NamedOffendersContainer data-testid={props['data-testid']}>
      <div>
        <CaseReportSectionTitle>{'Named offenders'}</CaseReportSectionTitle>
        {names.map((name) => (
          <BodyText weight="regular" margin="6px 0 0 0" key={name}>
            {name}
          </BodyText>
        ))}
      </div>
    </NamedOffendersContainer>
  );
};
